import styled from 'styled-components';
import InputMask from 'react-input-mask';

export const Container = styled.div`
  background: #f9f9fb 0% 0% no-repeat padding-box;
`;

export const TitleAcess = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;
  margin: 70px 0;

  @media (max-width: 759px) {
    padding: 0 20px;
    margin: 48px 0;
  }
`;

export const Form = styled.form`
  display: flex;
  justify-content: center;
`;
export const Validate = styled.div``;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 759px) {
    align-items: center;
  }
`;
export const Label = styled.label`
  text-align: left;
  font-size: 12px;
  letter-spacing: 0px;
  color: #2e384d;
  text-transform: uppercase;
  opacity: 1;
  margin-bottom: 16px;

  @media (max-width: 759px) {
    text-align: center;
    font-size: 16px;
  }
`;
export const Input = styled(InputMask)`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d7dbe4;
  border-radius: 4px;
  opacity: 1;
  width: 450px;
  height: 45px;
  margin-bottom: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;

  @media (max-width: 759px) {
    width: 295px;
    height: 40px;
  }
`;

export const ButtonForm = styled.button`
  background: #2196f3 0% 0% no-repeat padding-box;
  color: #fff;
  font-weight: 600;
  border-radius: 4px;
  border: none;
  opacity: 1;
  width: 449px;
  height: 45px;
  margin-top: 40px;
  font-size: 12px;

  @media (max-width: 759px) {
    width: 295px;
  }
`;
